// Fixes the button display bug when the page is loaded
document.addEventListener('DOMContentLoaded', () => {
    if (window.themeObject?.filterBtn) {
        window.themeObject.filterBtn.classList.replace('hide', 'show');
    }
});
